<template>
  <div class="micro-base-box">
    <div v-for="item in microAppList" :key="item.name" :id="item.name"
      v-show="$route.fullPath.startsWith(item.activeRule)">
    </div>
  </div>
</template>

<script>
import { loadMicroApp } from 'qiankun';

import mainBus from '@/micro/eventBus';
import { getMicroAppList } from '../micro/index';

export default {
  name: 'MicroBase',
  data() {
    return {
      microAppList: getMicroAppList(),
      loadedApp: {}, // 已加载的子应用
    };
  },
  created() {
    console.warn('micro base created');
  },
  watch: {
    '$route.fullPath': {
      handler() {
        const hasMicro = this.microAppList
          .find((app) => (this.$route.path.startsWith(app.activeRule)));
        if (hasMicro && hasMicro.name) {
          this.init(hasMicro);
        }
        this.routeCache();
      },
      immediate: true,
    },
  },
  mounted() {
    // 低代码传来的跨应用关闭页签
    mainBus.$on('lowcode_closeCurTab', (push) => {
      this.$store.commit('delCurTab', this.$route.fullPath);
      push();
    });
    // 低代码传来的跨应用跳转
    mainBus.$on('lowcode_mainRouter', (info) => {
      this.$router.push(info);
    });
    // zms传来的跨应用关闭页签
    mainBus.$on('zms_closeCurTab', () => {
      this.$store.commit('delCurTab', this.$route.fullPath);
    });
  },
  methods: {
    // apaas 返回上一级 路由存储
    routeCache() {
      let cacheData = localStorage.getItem('routeCache');
      if (!cacheData) {
        cacheData = [];
      } else {
        cacheData = JSON.parse(cacheData);
      }
      if (this.$route.path && this.$route.query) {
        cacheData.push({
          path: this.$route.path,
          query: this.$route.query,
        });
      }
      localStorage.setItem('routeCache', JSON.stringify(cacheData));
    },
    init(microApp) {
      if (!this.loadedApp[microApp.name]) {
        try {
          // 注入 父元素方法
          /* eslint-disable */
          microApp.props.util = {
            closeCurTab: this.closeCurTab,
            mainRouter: this.$router,
          };
          /* eslint-enable */
          const app = loadMicroApp(microApp);
          app.mountPromise.then(() => {
            this.loadedApp[microApp.name] = {
              app,
            };
          });
          // start({
          //   prefetch: 'all',
          // });
        } catch (e) {
          console.log(e);
        }
      }
    },
    closeCurTab(cb) {
      this.$store.commit('delCurTab', this.$route.fullPath);
      if (cb && typeof cb === 'function') {
        cb();
      } else {
        const panes = this.$store.state.tabs.list;
        if (panes.length > 0) {
          this.$router.push(panes[panes.length - 1].path);
        }
      }
    },
  },
  activated() {
    console.log('micro base activated');
  },
  deactivated() {
    console.log('micro base deactivated');
  },
};
</script>

<style lang="less" scoped>
.micro-base-box {
  width: 100%;
  min-width: 1100px;
  height: 100%;
}
</style>
